export default __webpack_public_path__ + "static/media/Yephome-Group-Rules.f66ba1a8.md";